<template>
  <div class="spwwHeaderPage disFlex">
    <div class="mainCont">
      <div class="leftCont"><img :src="logoSrc" width="115"></div>
      <div class="rightCont">
        <ul class="nav navbar-nav disFlex">
          <li>
            <router-link to="/">{{ $t('spww.home') }}</router-link>
          </li>
          <!-- 语言切换 -->
          <lang-select class="right-menu-item hover-effect" />
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import LangSelect from './components/LangSelect'
export default {
  components: {
    LangSelect
  },
  data() {
    return {
      logoSrc: require('@/assets/images/spww/Logo.png')
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
  .spwwHeaderPage {
    border-bottom: 1px solid #E5EDF5;
    box-shadow: 0px 0px 9px 0px rgba(7,60,127,0.5);
    .mainCont {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      height: 70px;
      background: #fff;
      .rightCont {
        ul {
          li {
            a {
              padding: 8px 15px;
              &:hover {
                color: #85BAE5;
              }
            }
          }
        }
      }
    }
    .disFlex {
      display: flex;
      .fixWidth {
        padding-right:5px;
      }
      .remain {
        flex: 1
      }
    }
  }
</style>
